import { ReactNode } from 'react';


function CardTemplate({ children, onUserClick }: { children: ReactNode, onUserClick: (id: string, role: string) => void }) {


    function goBack() {
        onUserClick('', '')
    }

    return (
        <div className="admin__details">
            <div className="details__headline">
                <button onClick={goBack}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L15 15" stroke="#D3D3D3" strokeWidth="2" />
                        <path d="M15 1L1 15" stroke="#D3D3D3" strokeWidth="2" />
                    </svg>
                </button>
            </div>
            <div className={`details__content`}>
                <div className="details__container">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default CardTemplate;